import React, { PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';

import { theme } from '@garnish/constants';

import { BodyText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientCardUpsellBadge = (props: Props) => {
  const { variant = 'default', children } = props;

  const containerStyle = [
    styles.container,
    variant === 'floating' ? styles.containerFloating : undefined,
  ];

  return (
    <Animated.View
      entering={FadeIn.duration(theme.transitions.short)}
      exiting={FadeOut.duration(theme.transitions.short)}
      style={containerStyle}
      pointerEvents="none"
    >
      <BodyText sizeMatch={['12']} style={styles.text} pointerEvents="auto">
        {children}
      </BodyText>
    </Animated.View>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    alignSelf: 'center',
    backgroundColor: theme.colors.CREAM,
    borderWidth: 1,
    borderColor: theme.colors.BLACK,
    borderRadius: theme.radius.medium,
    paddingVertical: 2,
    paddingHorizontal: theme.spacing['2'],
  },
  containerFloating: {
    position: 'absolute',
    bottom: theme.spacing['2'],
  },
  text: {
    color: theme.colors.DARK_KALE,
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  variant?: 'default' | 'floating';
}>;
